import { Component, OnInit } from '@angular/core';
import { IpClientService } from '@ats/ip/core';
import { Observable } from 'rxjs';

@Component({
    selector: 'ip-client-toolbar',
    templateUrl: './client-toolbar.component.html',
    styleUrls: ['./client-toolbar.component.scss'],
    standalone: false
})
export class IpClientToolbarComponent implements OnInit {
	client$: Observable<string>;
	clients$: Observable<string[]>;
	isClientListDisabled$: Observable<boolean>;

	constructor(private clients: IpClientService) {}

	ngOnInit() {
		this.clients$ = this.clients.clients$;
		this.client$ = this.clients.active$;
		this.isClientListDisabled$ = this.clients.isClientListDisabled$;
	}

	selectClient(id: string | null) {
		this.clients.selectClient(id);
	}
}
